
export enum VisibleSetting {
    Hidden = 0,
    Visible = 1,
}

export enum MandatoryAndVisibleSetting {
    Hidden = 0,
    Visible = 1,
    Mandatory = 2,
}

export enum MandatorySetting {
    NotMandatory = 1,
    Mandatory = 2,
}

export function isHidden(value: VisibleSetting | MandatoryAndVisibleSetting): boolean {
    return value === VisibleSetting.Hidden;
}

export function isMandatory(value: MandatoryAndVisibleSetting | MandatorySetting): boolean {
    return value === MandatoryAndVisibleSetting.Mandatory;
}